import { BORDER_COLORS } from '@constants/colors.ts';
import { Layout as BaseLayout } from 'antd';
import styled from 'styled-components';

export const Sider = styled(BaseLayout.Sider)`
    top: 0;
    bottom: 0;
    color: ${BORDER_COLORS.white};

    border-radius: 16px 0 16px 16px;
    background: linear-gradient(180deg, #298bce 0%, #335e9d 100%);

    inset-inline-start: 0;

    .ant-layout-sider-trigger {
        background: transparent;
    }
`;
